/* Used by Storefront */
import React from "react";
import { LinkedResourceResult, CategoryTopProductResult } from "~/common/Store/models/Category";
import FeaturedResources from "./Resources/FeaturedResources";
import NonFeaturedResources from "./Resources/NonFeaturedResources";
import SideBarVisibleHiddenText from "./SideBarVisibleHiddenText";
import TopProductsGrid from "./TopProductsGrid";
interface Props {
  headline?: string;
  visibleText?: string;
  hiddenText?: string;
  overflowText?: string;
  visibleMarkup?: string;
  showTopProducts: boolean;
  hideHiddenText: boolean;
  linkedResources: LinkedResourceResult[];
  displayTopProductsInMainContainer: boolean;
  categoryTopProducts: CategoryTopProductResult[];
}
const Sidebar = ({
  headline,
  visibleText,
  showTopProducts,
  linkedResources,
  hideHiddenText,
  displayTopProductsInMainContainer,
  categoryTopProducts,
  visibleMarkup,
  overflowText
}: Props) => {
  const nonFeaturedLinkedResources = linkedResources.filter(x => x.isFeatured !== true);
  const showSideBarVisibleHiddenText = !!headline && !!visibleText;
  const showNonFeaturedResources = linkedResources && nonFeaturedLinkedResources.length > 0;
  function createPaddedTextBox() {
    return <>
        <div className="box padded text">
          <SideBarVisibleHiddenText headline={headline || ""} visibleText={visibleText || ""} hideHiddenText={hideHiddenText} visibleMarkup={visibleMarkup} overflowText={overflowText} data-sentry-element="SideBarVisibleHiddenText" data-sentry-source-file="Sidebar.tsx" />
          <p></p>
          {linkedResources && nonFeaturedLinkedResources.length > 0 && <NonFeaturedResources linkedResources={nonFeaturedLinkedResources} />}
        </div>
      </>;
  }
  return <>
      {linkedResources && <FeaturedResources linkedResources={linkedResources} />}
      <div className="clears"></div>
      <div className="clears"></div>
      {(showSideBarVisibleHiddenText || showNonFeaturedResources) && createPaddedTextBox()}
      {showTopProducts && !displayTopProductsInMainContainer && <TopProductsGrid topProducts={categoryTopProducts} />}
    </>;
};
export default Sidebar;